/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type OrderByJoblistingType = "COMPANY_NAME" | "COMPANY_NAME_INVERSE" | "CREATED" | "CREATED_INVERSE" | "DEADLINE" | "DEADLINE_INVERSE" | "ID" | "ID_INVERSE" | "TYPE" | "TYPE_INVERSE" | "%future added value";
export type JoblistingsContainer_QueryVariables = {
    count?: number | null;
    cursor?: string | null;
    type?: string | null;
    fromGrade?: number | null;
    toGrade?: number | null;
    company?: string | null;
    towns?: Array<string | null> | null;
    orderBy?: Array<OrderByJoblistingType | null> | null;
};
export type JoblistingsContainer_QueryResponse = {
    readonly " $fragmentRefs": FragmentRefs<"JoblistingsContainer_root">;
};
export type JoblistingsContainer_Query = {
    readonly response: JoblistingsContainer_QueryResponse;
    readonly variables: JoblistingsContainer_QueryVariables;
};



/*
query JoblistingsContainer_Query(
  $count: Int
  $cursor: String
  $type: String
  $fromGrade: Float
  $toGrade: Float
  $company: ID
  $towns: [ID]
  $orderBy: [OrderByJoblistingType]
) {
  ...JoblistingsContainer_root_3RFniq
}

fragment JoblistingsContainer_joblisting on Joblisting {
  slug
  id
  __typename
  type
  title
  url
  deadline
  towns {
    name
    id
  }
  company {
    name
    logo(width: 800, height: 260)
    id
  }
}

fragment JoblistingsContainer_root_3RFniq on Query {
  joblistings(first: $count, after: $cursor, type: $type, company: $company, fromGrade: $fromGrade, toGrade: $toGrade, towns: $towns, orderBy: $orderBy) {
    edges {
      node {
        id
        ...JoblistingsContainer_joblisting
        __typename
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "company"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cursor"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fromGrade"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "toGrade"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "towns"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v8 = {
  "kind": "Variable",
  "name": "company",
  "variableName": "company"
},
v9 = {
  "kind": "Variable",
  "name": "fromGrade",
  "variableName": "fromGrade"
},
v10 = {
  "kind": "Variable",
  "name": "orderBy",
  "variableName": "orderBy"
},
v11 = {
  "kind": "Variable",
  "name": "toGrade",
  "variableName": "toGrade"
},
v12 = {
  "kind": "Variable",
  "name": "towns",
  "variableName": "towns"
},
v13 = {
  "kind": "Variable",
  "name": "type",
  "variableName": "type"
},
v14 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  (v8/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v9/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "JoblistingsContainer_Query",
    "selections": [
      {
        "args": [
          (v8/*: any*/),
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          },
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "JoblistingsContainer_root"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v7/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v6/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "JoblistingsContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": (v14/*: any*/),
        "concreteType": "JoblistingConnection",
        "kind": "LinkedField",
        "name": "joblistings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "JoblistingEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Joblisting",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slug",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deadline",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Town",
                    "kind": "LinkedField",
                    "name": "towns",
                    "plural": true,
                    "selections": [
                      (v16/*: any*/),
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Company",
                    "kind": "LinkedField",
                    "name": "company",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "height",
                            "value": 260
                          },
                          {
                            "kind": "Literal",
                            "name": "width",
                            "value": 800
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "logo",
                        "storageKey": "logo(height:260,width:800)"
                      },
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v14/*: any*/),
        "filters": [
          "toGrade",
          "fromGrade",
          "company",
          "type",
          "towns",
          "orderBy"
        ],
        "handle": "connection",
        "key": "Joblistings_joblistings",
        "kind": "LinkedHandle",
        "name": "joblistings"
      }
    ]
  },
  "params": {
    "cacheID": "20bd186858522bf4827e3ce4bca9b88f",
    "id": null,
    "metadata": {},
    "name": "JoblistingsContainer_Query",
    "operationKind": "query",
    "text": "query JoblistingsContainer_Query(\n  $count: Int\n  $cursor: String\n  $type: String\n  $fromGrade: Float\n  $toGrade: Float\n  $company: ID\n  $towns: [ID]\n  $orderBy: [OrderByJoblistingType]\n) {\n  ...JoblistingsContainer_root_3RFniq\n}\n\nfragment JoblistingsContainer_joblisting on Joblisting {\n  slug\n  id\n  __typename\n  type\n  title\n  url\n  deadline\n  towns {\n    name\n    id\n  }\n  company {\n    name\n    logo(width: 800, height: 260)\n    id\n  }\n}\n\nfragment JoblistingsContainer_root_3RFniq on Query {\n  joblistings(first: $count, after: $cursor, type: $type, company: $company, fromGrade: $fromGrade, toGrade: $toGrade, towns: $towns, orderBy: $orderBy) {\n    edges {\n      node {\n        id\n        ...JoblistingsContainer_joblisting\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '4094b7eee5533bacba92cdb37b00e9fb';
export default node;
